import { Fragment, useState } from "react";
import {
  Button,
  Input,
  Switch,
  Select,
  Option,
  Progress,
} from "@material-tailwind/react";
import { FaCopy } from "react-icons/fa";
import "./formBuilder.css";
import { formEl } from "../constants";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";

const SliderInput = ({
  item,
  index,
  handleValue,
  handleSliderValue,
  deleteEl,
  handleRequired,
  handleElType,
  duplicateElement,
  handleSave,
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const saveData = (id) => {
    setIsSaving(true);
    handleSave(id);
    setTimeout(() => {
      setIsSaving(false);
    }, 1000); // Simulate save delay
  };

  return (
    <Fragment>
      {item.saved ? (
        <div className="form-group-container relative">
          <div className="text-base">
            <label>
              {item.required && "* "}
              {index + 1 + ". " + item.value}
            </label>
          </div>
          <div className="p-3">
            <span className="float-left font-bold">{item.min}</span>
            <span className="float-right font-bold">{item.max}</span>
            <Slider
              min={item.min}
              max={item.max}
              orientation="horizontal"
              disabled={true}
            />
          </div>
          <div className="absolute top-0 right-0 flex justify-end items-center gap-2 buttons-container">
            <Button size="sm" color="gray" onClick={() => saveData(item.id)}>
              Edit
            </Button>
            <Button size="sm" color="red" onClick={() => deleteEl(item.id)}>
              Delete
            </Button>
            <Button
              size="sm"
              color="blue-gray"
              onClick={() => duplicateElement(item.id, item.type)}
            >
              Duplicate
            </Button>
          </div>
        </div>
      ) : (
        <div className="bg-white border px-3 py-2 border-dark rounded-sm text-sm font-normal text-dark w-full p-1">
          <div className="px-2 py-2 flex flex-wrap">
            <div className="w-full md:w-3/4">
              <div className="flex gap-2 items-center mb-4">
                <label className="text-lg mb-0">Q.{index + 1}.</label>
                <Input
                  type="text"
                  label="Enter your question"
                  defaultValue={item.value}
                  onBlur={(e) => handleValue(item.id, e)}
                  required={item.required}
                />
              </div>
              <div className="flex gap-2 items-center mb-4">
                <label className="text-lg mb-0">Min:</label>
                <Input
                  size="lg"
                  type="number"
                  defaultValue={item.min}
                  onBlur={(e) => handleSliderValue(item.id, e, "min")}
                  required
                  placeholder="Min value"
                />

                <label className="text-lg mb-0">Max:</label>
                <Input
                  size="lg"
                  type="number"
                  defaultValue={item.max}
                  onBlur={(e) => handleSliderValue(item.id, e, "max")}
                  required
                  placeholder="Max value"
                />
              </div>
            </div>
            <div className="w-full md:w-1/4">
              <Select
                size="lg"
                value={item.type}
                onChange={(value) => handleElType(item.id, value)}
              >
                {formEl &&
                  formEl.map((el, key) => (
                    <Option key={key} value={el.value}>
                      {el.label}
                    </Option>
                  ))}
              </Select>
            </div>
          </div>
          <hr />
          <div className="flex justify-between items-center mt-2 gap-2">
            <div className="flex items-center">
              <Switch
                checked={item.required}
                onChange={() => handleRequired(item.id)}
                label="Required"
              />
            </div>
            <div className="flex justify-start items-center gap-2">
              <Button
                size="sm"
                variant="outlined"
                color="red"
                onClick={() => deleteEl(item.id)}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                className="bg-[#000080]"
                onClick={() => saveData(item.id)}
              >
                Save
              </Button>
              <Button
                size="sm"
                color="gray"
                onClick={() => duplicateElement(item.id, item.type)}
              >
                <FaCopy className="text-secondary" />
              </Button>
            </div>
          </div>
          {isSaving && <Progress color="green" value={100} />}
        </div>
      )}
    </Fragment>
  );
};

export default SliderInput;
